import { render, staticRenderFns } from "./KPIHome.vue?vue&type=template&id=0bbe89c7&scoped=true"
import script from "./KPIHome.vue?vue&type=script&lang=js"
export * from "./KPIHome.vue?vue&type=script&lang=js"
import style0 from "./KPIHome.vue?vue&type=style&index=0&id=0bbe89c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe89c7",
  null
  
)

export default component.exports